__webpack_require__.p = "https://gamma.ergona.whs.amazon.dev/";